import MaxWeightPreservedTypography from 'components/utils/MaxWeightPreservedTypography'
import useRebrandVersion from 'hooks/useRebrandVersion'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'

const Label = styled(MaxWeightPreservedTypography)`
  transition: color 200ms;
`

interface Props extends PropsWithChildren {
  state: 'active' | 'inactive' | 'completed'
  underline?: boolean
}

function StepLabel(props: Props) {
  const { children, state, underline } = props
  const isRebrand = useRebrandVersion() === 'rebrand'
  const colour = state === 'inactive' && isRebrand ? 'light-foreground-alt' :
    state === 'inactive' ? 'light-foreground' : 'normal-contrast'

  return <Label
    underline={underline}
    Typography={BodyText}
    variant="medium"
    weight={state !== 'inactive' ? 'bold' : 'normal'}
    colour={colour}
    wrap="no-wrap"
  >
    {children}
  </Label>
}

export default StepLabel
